<c-container class="mt-5">

  <h2>Causable Ledger</h2>

  <app-choose-your-game [message]="'Choose an organization to view what it owes Causable'"
                        (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>

  @if (game) {
    <app-causable-ledger [gameData]="game"></app-causable-ledger>
  }

</c-container>
